import React from 'react';
import './App.css';
import 'antd/dist/antd.css'
import './TextLayer.css';

import './theme.css'
import MainPage from './pages/index';
// import 'react-resizable/css/styles.css';
import { HashRouter, Route, Link } from "react-router-dom";
import { withDomains, RESTExecutor } from './lib/domain';
import AuthPage from './pages/auth/index';
import ChangePassword from './pages/auth/change_password';
import IdleTimer from 'react-idle-timer';
import { COLORS } from './pages/theme';
import { WhiteLabelProvider } from 'react-whitelabel';
import companyProvider from './details.json';
import ExpiryView from './views/expiry_view';
// theme css file

class App extends React.Component {
  constructor(props) {
    super(props)

    this.state = {

    }

    this.idleTimer = null
    this.onAction = this._onAction.bind(this)
    this.onActive = this._onActive.bind(this)
    this.onIdle = this._onIdle.bind(this);

    console.log('%cStop!', 'color:red; font-size:60px; font-weight: bold; -webkit-text-stroke: 1px black;');
    console.log("%cThis is a browser feature intended for developers. Please dont share any information from here.", 'font-size: 18px;');

    if (process.env.NODE_ENV === 'production') {
      console.log = function () { }
      console.warn = function () { }
      console.error = function () { }
      window.console.log = function () { }
      window.console.warn = function () { }
      window.console.error = function () { }
    }

    this.logout_user = RESTExecutor.post().config({
      label: 'logout'
    }).callbacks((success) => {
      // this.setState({
      //   modal_visible:false,
      //   confirmLoading:false
      // })
      // try{
      //   props.authenticator.initializer()
      // }catch(e){
      // }
    }, (error) => {
      // showErrorInNotification(error)
    }).connect(props.domains.profile);



  }
  _onAction(e) {
    // console.log('user did something', e)
  }

  _onActive(e) {
    // console.log('user is active', e)
    // console.log('time remaining', this.idleTimer.getRemainingTime())
  }

  _onIdle(e) {
    // console.log('user is idle', e);
    let { authenticator } = this.props;
    if (authenticator.isAuthenticated()) {
      // Commented for demo purpose only

      // this.logout_user.execute();
      // authenticator.logout();
    }
    // console.log('last active', this.idleTimer.getLastActiveTime())
  }

  render() {
    // return <AuthPage/>
    let { authenticator } = this.props;
    let meta = authenticator.getTokens().meta || {};
    let logout_time = authenticator.getTokens().logout_time || 10;
    let permissions = meta.permissions || [];

    // return <TestPage/>
    return (
      <HashRouter>

        <WhiteLabelProvider labels={{
          'main':companyProvider
        }} selectedLabel={'main'}>
          <div style={{
            backgroundColor: COLORS.main_bg_color,
            minHeight: '100vh',
          }} >
            <ExpiryView/>
            <IdleTimer
              ref={ref => { this.idleTimer = ref }}
              element={document}
              onActive={this.onActive}
              onIdle={this.onIdle}
              onAction={this.onAction}
              debounce={250}
              timeout={1000 * 60 * logout_time} />
            {authenticator.isAuthenticated() ?
              (!authenticator.hasChangedPassword()) ?
                <ChangePassword /> :
                <MainPage permissions={permissions} />
              : <AuthPage />
            }
          </div>
        </WhiteLabelProvider>
      </HashRouter>
    );
  }
}

export default withDomains(App, "adminAuth", "profile");

